module.exports = __webpack_public_path__ + "static/media/available_soon.95b2483e.svg";